module.exports = __webpack_public_path__ + "static/img/1.cb88fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/users/1.jpg
// module id = mSs3
// module chunks = 17